/*
 * @Author: 李光辉 ligh02@mingyuanyun.com
 * @Date: 2023-07-10 10:56:00
 * @LastEditors: 李光辉 ligh02@mingyuanyun.com
 * @LastEditTime: 2023-07-17 10:44:56
 * @FilePath: /app-console-web/Users/liguanghui/Desktop/work/app-studio-web/src/common/utils/request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie'
import { bus } from './event'

const requestMap = {}

const request = axios.create()

const requestSuccess = config => {
    const { method, url, isCancel = true } = config
    if (method === 'get') {
        if (requestMap[url]) {
            requestMap[url].cancel()
        }
        if (isCancel) {
            requestMap[url] = axios.CancelToken.source()
            config.cancelToken = requestMap[url].token
        }
    }
    return config
}

const responseSuccess = res => {
    const { status, headers } = res
    const { url, method } = res.config
   
    if (headers['api-type'] === 'restful') {
        if ((status >= 200 && status < 300) || res.data) {
            return res.data
        }
    } else if (method === 'get' && requestMap[url]) {
        delete requestMap[url]
    }
    const {
        code, data, msg, errors,
    } = res.data
    if (code === 200 || code === 0) {
        return Promise.resolve(data)
    }
    if (code === 404) {
        bus.$emit('404')
    }

    // 角色页面配置需要完整信息
    if (errors) {
        return Promise.reject(res.data)
    }
    return Promise.reject(msg)
}

const responseError = err => {
    const { response = {} } = err
    const { headers = {} } = response
    if (headers['tenant-permission-limit']) {
        setTimeout(() => {
            const { origin, protocol } = window.location
            const env = (origin.match(/studio-(dev|test|beta)/) || [])[1]
            const envfix = env ? `-${env}` : ''
            const url = protocol.includes('https')
                ? `https://app${envfix}.mypaas.com.cn/package-details`
                : `https://app${envfix}.mypaas.com.cn/#/package-details`
            window.open(url)
        }, 600)
    }
    if (response) {
        const { status } = response
        if (status === 404) {
            Cookies.remove('passport')
            bus.$emit('404')
        } else if (status === 401) {
            bus.$emit('401')
        }
    }
    const errorMsg = response?.data?.msg ?? response?.data?.error ?? response?.data ?? err.message
    if (errorMsg) {
        Vue.prototype.$message.error(errorMsg)
    }
    
    return Promise.reject(errorMsg)
}

request.interceptors.request.use(requestSuccess, err => Promise.reject(err))
request.interceptors.response.use(responseSuccess, responseError)

export default request
